import { useEffect, useState } from 'react';
import { HorizontalView, VerticalView } from 'src/components/FlexViews';
import styled from 'styled-components';
import { Button } from '../../components/Button';
import { useNavigate } from 'react-router-dom';
import { bonusGameApi } from 'src/api/bonus-game';
import { useUserContext } from '../../contexts/UserContext';
const PageWrapper = styled(VerticalView)`
  justify-content: center;
`;
const PromoModalWrapper = styled(VerticalView)`
  background: rgba(83, 89, 98, 0.25);
  border-radius: 24px;
  padding: 20px 16px;
  gap: 24px;
`;

const Title = styled.p`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
`;

const InputStyled = styled.input`
  height: 48px;
  padding: 12px 16px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.25);
  border: none;
  outline: none;
  overflow: hidden;
  color: #fff;
  text-align: center;
  text-overflow: ellipsis;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  caret-color: #c4f538;
`;

const ErrorText = styled.p`
  color: #dd8585;
  text-align: center;
  font-family: Public-Sans, sans-serif;
  font-size: 10px;
`;

export const Promo = () => {
  const [value, setValue] = useState('');
  const [errorText, setErrorText] = useState('');
  const navigate = useNavigate();
  const { setPromocode } = useUserContext();

  useEffect(() => {
    const handleResize = (event: Event) => {
      console.log(event.target as VisualViewport);
    };

    window.visualViewport?.addEventListener('resize', handleResize);

    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize);
    };
  }, []);

  const applyCode = async () => {
    const exists = (await bonusGameApi.checkInviteCode({ promoCode: value }))
      .result;
    if (exists) {
      setPromocode(value);
      navigate('/bonus-game/season-info');
    } else {
      setErrorText('This promo-code doesn’t exists');
    }
  };

  return (
    <PageWrapper>
      <PromoModalWrapper>
        <Title>Enter promo code</Title>
        <VerticalView style={{ gap: '8px' }}>
          <InputStyled value={value} onChange={e => setValue(e.target.value)} />
          {errorText && <ErrorText>{errorText}</ErrorText>}
        </VerticalView>
        <HorizontalView style={{ gap: '8px' }}>
          <Button
            style={{ width: '50%' }}
            title="Back"
            onClick={() => navigate(-1)}
          />
          <Button
            buttonStyle="primary"
            style={{ width: '50%' }}
            title="Apply Code"
            onClick={applyCode}
          />
        </HorizontalView>
      </PromoModalWrapper>
    </PageWrapper>
  );
};
